<div class="buttonSnippetDs__cont" [class.disabled]="isDisabled">
  <button
    class="buttonSnippetDs__cont__modify-action"
    aria-label="buttonSnippetDs"
    [class.disabled]="isDisabled"
    (click)="modify(false)">
    <app-ds-icon
      [icon]="substract"
      [color]="iconFillColor(!canSubstract)"
      [size]="20">
    </app-ds-icon>
  </button>
  <div class="buttonSnippetDs__cont__value">
    <app-ds-typography
      [size]="typographyFontSizeXXS"
      [fontFamily]="typographyFontFamilySemiBold"
      [color]="typographyColor"
      [text]="snippetValue">
    </app-ds-typography>
  </div>
  <button
    class="buttonSnippetDs__cont__modify-action"
    aria-label="buttonSnippetDs"
    [class.disabled]="isDisabled"
    (click)="modify(true)">
    <app-ds-icon
      [icon]="add"
      [color]="iconFillColor(!canIncrease)"
      [size]="20">
    </app-ds-icon>
  </button>
</div>